import {User} from "services/entities/auth";

export function formatUserName(user: User, fullName: boolean = true): string {
  if(user.firstName && user.lastName && fullName) {
    return `${user.firstName} ${user.lastName}`;
  } else if(user.firstName) {
    return user.firstName;
  } else {
    return user.username;
  }
}